module.exports = "//cdn-static.ap4r.com/kos/s101/nlav11312/topick/topick-h5-dist/static/img/topickTag.f79583ca.png";